(function () {
  document.documentElement.classList.add('jd-js');

  function initHeader() {
    var header = document.querySelector('[data-jd-header]');
    var drawer = document.querySelector('[data-jd-drawer]');
    var toggle = document.querySelector('[data-jd-menu-toggle]');
    if (!header) return;

    function updateHeader() {
      header.classList.toggle('is-scrolled', window.scrollY > 20);
    }
    updateHeader();
    window.addEventListener('scroll', updateHeader, { passive: true });

    if (drawer && toggle) {
      toggle.addEventListener('click', function () {
        var open = !drawer.classList.contains('is-open');
        drawer.classList.toggle('is-open', open);
        document.body.classList.toggle('jd-menu-open', open);
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
      drawer.querySelectorAll('a').forEach(function (link) {
        link.addEventListener('click', function () {
          drawer.classList.remove('is-open');
          document.body.classList.remove('jd-menu-open');
          toggle.setAttribute('aria-expanded', 'false');
        });
      });
    }
  }

  function initSliders() {
    document.querySelectorAll('[data-jd-slider-wrap]').forEach(function (wrap) {
      var slider = wrap.querySelector('[data-jd-slider]');
      if (!slider) return;
      wrap.querySelectorAll('[data-jd-slide-dir]').forEach(function (button) {
        button.addEventListener('click', function () {
          var direction = button.getAttribute('data-jd-slide-dir') === 'prev' ? -1 : 1;
          slider.scrollBy({ left: direction * slider.clientWidth * 0.78, behavior: 'smooth' });
        });
      });
    });
  }

  function initReveal() {
    var items = document.querySelectorAll('.jd-reveal');
    if (!items.length) return;
    if (!('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -5% 0px' });
    items.forEach(function (el) { observer.observe(el); });
  }

  function init() {
    initHeader();
    initSliders();
    initReveal();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function () {
    initSliders();
    initReveal();
  });
})();
